uniform sampler2D videoTexture;
uniform float edgeTransparency;
uniform float globalOpacity;

varying vec2 vUv;
varying float vCameraDistance;

const float minDistance = 400.0;
const float maxDistance = 1400.0;

void main() {
    vec4 color = texture2D(videoTexture, vUv);
    
    // Edge transparency (simplified)
    vec2 edgeDist = min(vUv, 1.0 - vUv);
    float minEdgeDist = min(edgeDist.x, edgeDist.y);
    float edgeAlpha = smoothstep(0.0, edgeTransparency, minEdgeDist);
    
    // Distance attenuation
    float distanceAttenuation = 1.0 - smoothstep(minDistance, maxDistance, vCameraDistance);
    
    // Final alpha
    float finalAlpha = edgeAlpha * globalOpacity * distanceAttenuation;
    
    // Apply distance fading to color (fade to darker/transparent instead of white)
    vec3 finalColor = color.rgb * distanceAttenuation;
    
    gl_FragColor = vec4(finalColor, finalAlpha);
}
